export default "__VITE_PUBLIC_ASSET__e7e993d6__"